module.exports = __webpack_public_path__ + "media/images/redesign-images/home-new/ig-images/ig-10-8d9410b9419608c27b774d6c1b3630ab.jpg";